import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FocusArrow = props => (
  <svg viewBox="0 0 20 20" className="focusArrow">
    <path d="M0 0 L10 10 L0 20" />
  </svg>
);

const InputLine = props => (
  <svg className="inputLine" viewBox="0 0 40 2" preserveAspectRatio="none">
    <path d="M0 1 L40 1" />
    <path d="M0 1 L40 1" className="activeFocus" />
  </svg>
);

const InputField = (props) => {
  const {
    defaultVal, change, fieldType, fieldName, fieldPlaceholder, icon, focus,
  } = props;
  return (
    <p>
      <input
        defaultValue={defaultVal}
        onChange={change}
        type={fieldType}
        name={fieldName}
        placeholder={fieldPlaceholder}
        required
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={!!focus}
      />
      <FocusArrow />
      <FontAwesomeIcon icon={['fas', icon]} />
      <InputLine />
    </p>
  );
};

export default InputField;

InputField.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  fieldType: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldPlaceholder: PropTypes.string.isRequired,
  focus: PropTypes.bool,
};

InputField.defaultProps = {
  defaultVal: '',
  focus: false,
};
